/* eslint-disable operator-linebreak */
import { createI18n } from 'vue-i18n';
import I18nLabelSubstitutionFormatter from 'bumblebee/helpers/i18n_label_substitution_formatter';
import I18nTranslationMessageLoader from 'bumblebee/helpers/i18n_translation_message_loader';

const currentLocale = document ? document.querySelector('html').getAttribute('lang') : 'en-GB';

// Load translation messages
const translationMessages = I18nTranslationMessageLoader.load({ locale: currentLocale });

// Create i18n formatter
const i18nFormatter = new I18nLabelSubstitutionFormatter(/* here the constructor options */);
// Load translations asynchronously and wait for completion
let formatterReady = false;
i18nFormatter
  .loadTranslations()
  .then(() => {
    formatterReady = true;
  })
  .catch((error) => {
    console.warn('Failed to load i18n formatter translations:', error);
  });

// Create Vue 3 i18n instance
// legacy: true aligns with vue.js and bumblebee-vue packs so shared bumblebee
// components (BeepleInput, BeepleForm, etc.) work consistently across entry points
const i18n = createI18n({
  legacy: true,
  allowComposition: true,
  locale: currentLocale,
  fallbackLocale: 'en-GB',
  messages: translationMessages,
  globalInjection: true,
});

// Integrate custom formatter with Vue 3 i18n
const originalT = i18n.global.t;
i18n.global.t = function (key, ...args) {
  let result = originalT.call(this, key, ...args);

  // Handle alias support (existing functionality)
  if (result[0] === ':') {
    const aliasedKey = result.substring(1);
    result = originalT.call(this, aliasedKey, ...args);
  }

  // Apply custom formatter to process &{Label.xxx} and &{label.xxx} syntax
  if (
    formatterReady &&
    i18nFormatter &&
    i18nFormatter.interpolate &&
    typeof result === 'string' &&
    (result.includes('&{Label.') || result.includes('&{label.'))
  ) {
    try {
      const [interpolated] = i18nFormatter.interpolate(result, args[0] || {});
      if (interpolated && interpolated !== result) {
        result = interpolated;
      }
    } catch (error) {
      console.warn('Error processing custom formatter:', error, 'for result:', result);
      // Return the original result if formatter fails
    }
  }

  return result;
};

// Helper function for customer portal translations
const tn = (...args) => {
  const [key, otherArgs] = args;
  const prefixedKey = `customer_portal.${key}`;
  // Use the custom t function that includes formatter integration
  return i18n.global.t(prefixedKey, otherArgs);
};

// Export both the i18n instance and helper functions
export default i18n;
export { tn };
